<template>
    <article class="infos-item">
        <h3 class="item-title">{{about_data.title}}</h3>
        <div class="item-content">
            <p v-for="(value) of about_data.text" v-html="value" v-bind:key="value.title"></p>
            
            <ul class="list list--tertiary list--skills" v-if="about_data.skills">
                <li class="list-item" v-for="(value) of about_data.skills" v-bind:key="value.title">
                    <span class="item-gradient">{{value}}</span>
                </li>
            </ul>
            
            <ul class="list list--tertiary list--social" v-if="about_data.socials">
                <li class="list-item" v-for="(value) of about_data.socials" v-bind:key="value.title">
                    <a class="c-hover" :href="value.url" target="_blank" v-bind:title="value.title">
                        <span class="icon c-hover" v-bind:class="value.icon"></span>
                    </a>
                </li>
            </ul>
        </div>
        <div class="clear"></div>
    </article>
</template>

<script>

    export default {
        props: ['about_data']
    }

</script>


// WEBPACK FOOTER //
// src/components/AboutItem/AboutItem.vue